export default "__VITE_ASSET__BX$jQ974__"